import React from 'react'
import { useDispatch } from 'react-redux'
import { IAxiosDefaultDataObject } from '../../config'
import { Dispatch, UnknownAction } from '@reduxjs/toolkit'
import AdminDynamicCreateOrUpdatePage from '../admin/AdminDynamicCreateOrUpdatePage'
import { updateCategory } from './categoriesSlice'
import { ICategoryModel } from './CategoriesApp'

export default function NewCategoryPage() {

    const updateItem = (item: IAxiosDefaultDataObject, dispatch: Dispatch<UnknownAction>) => {
        dispatch(updateCategory((item as ICategoryModel)))
    }

    return <AdminDynamicCreateOrUpdatePage updateItem={updateItem} />
}